// extracted by mini-css-extract-plugin
export default {"Root":"Highlight_Root__5lnRF"};